<div *ngIf="existingbooking" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 4% 2% 2%">
                  <div class="instruct">
                    <div class="int1" style="margin-left: 17px">
                      <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                      <br />
                      <span class="txt">
                        1. Select atleast one value out of INTERMILES Number,Airline PNR,Booking Reference No,Ticket No,
                        Payment Status.

                      </span>
                      <br />
                      <span class="txt">
                        2. If using date range enter both 'From' and 'To' booking date
                      </span>
                      <br />
                        <span class="txt">
                        3. Please enter a 9-digit IM Number, or an 11-digit Number with `00` prefixed to the 9-digit IM Number.
                        </span>
                      <br />
                      <span></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div class="col-md-3">
                        <label>INTERMILES Number </label>
                        <input [(ngModel)]="search_details.jp_number" maxlength="11" type="text"
                          class="form-control m-input" placeholder="Enter INTERMILES Number"
                          (keyup)="jpNumberValidation();" (input)="isEmpty()" (blur)="jpNumberValidation1()"
                          (keypress)='keypresshandler($event)' />
                        <span id="JpErr"></span>
                      </div>

                      <div class="col-md-3">
                        <label class="">Airline PNR</label>
                        <input [(ngModel)]="search_details.airlinepnr" style="text-transform: uppercase" type="text"
                          class="form-control m-input" placeholder="Enter Airline PNR"
                          (keyup)="pnrValidation(); checkempty()" (blur)="pnrValidation1()" (input)="isEmpty()"
                          maxlength="6" />
                        <span id="pnrNO"></span>
                      </div>

                      <div class="col-md-3">
                        <label class="">Booking Reference No </label>
                        <input [(ngModel)]="search_details.order_id" type="text" class="form-control m-input"
                          style="text-transform: uppercase" placeholder="Enter Booking Reference No"
                          (keyup)="orderValidation(); " (input)="isEmpty()" maxlength="18"
                          (blur)="orderValidation1()" />
                        <span id="orErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Ticket No </label>
                        <input [(ngModel)]="search_details.Ticket_No" type="text" class="form-control m-input"
                          placeholder="Enter Ticket No" maxlength="15" (input)="isEmpty()" />
                        <span id="orErr"></span>
                      </div>
                      <div class="clr"></div>
                      <div class="divider"></div>
                      <div class="col-md-3">
                        <label class="">Payment Status</label>
                        <select class="form-control m-input" (change)="isEmpty()" [(ngModel)]="search_details.status">
                          <option value="E" disabled>Select</option>
                          <option value="">All</option>

                          <option *ngFor="let item of payment_status" value="{{ item.key }}">{{ item.value }}</option>
                        </select>
                      </div>

                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input id="did" #input3 matInput [(ngModel)]="search_details.bookingdate_from"
                            [matDatepicker]="pickerFrom1" (dateChange)="checkStatus1();incresedate();checkDate();"
                            (dateChange)="toggleDisable2();incresedate();isEmpty();" [disabled]="bookingdate"
                            autocomplete="off" placeholder="From Booking Date" [max]="myDate" readonly />
                          <mat-datepicker-toggle matSuffix [for]="pickerFrom1"></mat-datepicker-toggle>
                          <mat-datepicker #pickerFrom1></mat-datepicker>
                        </mat-form-field>

                        <button type="button" class="close opa" (click)="reset3();checkStatus1();" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br>

                      </div>

                      <div class="col-md-3" style="margin-top: 19px">

                        <mat-form-field>
                          <input [min]="final" #input4 matInput [disabled]="bookingdate"
                            [(ngModel)]="search_details.bookingdate_to" [matDatepicker]="pickerTO" [max]="newDate"
                            autocomplete="off" placeholder="To Booking Date" readonly (dateChange)="isEmpty();" />
                          <mat-datepicker-toggle matSuffix [for]="pickerTO"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTO></mat-datepicker>
                        </mat-form-field>
                        <button type="button" class="close opa" (click)="reset4();checkStatus1();" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br>
                      </div>
                      <div class="clr"></div>
                      <div class="divider"></div>
                    </div>
                  </div>
                </div>
                <div class="clr"></div>
                <app-shared-button [IsEmptyVal]="IsEmptyVal" (selectedTypeOfRedemption)="selectTypeOfRedemption($event)"
                  (searchingData)="searchData($event)"></app-shared-button>

                <div class="errwrap">
                  <div class="errdiv1" id="err"></div>
                </div>
                <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list != '' || search_detail_list != 0"
                  [hidden]="searchlist">
                  <table aria-describedby="pgReportBookingDetails" class="table table-striped" *ngIf="!loader"
                    [mfData]="serachtabledata" [mfRowsOnPage]="5">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 10%">Booking Reference No</th>
                        <th scope="col" style="width: 10%">INTERMILES Number</th>
                        <th scope="col" style="width: 10%">Airline Pnr</th>
                        <th scope="col" style="width: 10%">Transaction Date</th>
                        <th scope="col" style="width: 10%">Total Amount</th>
                        <th scope="col" style="width: 10%">Payment Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let item of (search_detail_list
                            | paginate: { itemsPerPage: 10, currentPage: p })
                        ">
                        <td>{{ item.BOOKING_REF_NO }}</td>
                        <ng-container *ngIf="typeOfRedem == 'A'">
                          <td>{{ item.JP_NUMBER }}</td>
                        </ng-container>
                        <ng-container *ngIf="typeOfRedem == 'R'">
                          <td>{{ (item.JP_NUMBER).slice(2,11) }}</td>
                        </ng-container>
                        <td>{{ item.AIRLINE_PNR }}</td>
                        <td>{{ item.CREATED_DATE }}</td>
                        <td>{{ item.ORDER_AMOUNT }}</td>
                        <td>{{ item.PAYMENT_STATUS }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="7">
                          <pagination-controls (pageChange)="p = $event"></pagination-controls>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list == '' || search_detail_list == 0">
                  <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr">
                    {{ noresult }}
                  </h1>
                </div>
                <div *ngIf="loader">
                  <div style="margin: 0 auto; text-align: center;">
                    <img src="../../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>